import React from 'react';
import { Landmark, Globe, Camera, Share2, MessageSquare } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-luxury-black pt-20 pb-10 text-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          {/* Brand */}
          <div className="space-y-8">
            <div className="flex items-center gap-3 group cursor-pointer mb-8">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-yellow-600 rounded-lg flex items-center justify-center group-hover:rotate-12 transition-transform duration-500 shadow-[0_0_15px_rgba(249,115,22,0.4)]">
                <Landmark className="text-white w-5 h-5" />
              </div>
              <span className="text-2xl font-serif font-light tracking-widest text-white">
                GPHUB <span className="text-orange-400 font-normal">LUXURY</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-loose">
              Experience the pinnacle of luxury and comfort in the heart of Hyderabad. Our suites are designed for those who settle for nothing but the best.
            </p>
            <div className="flex gap-4">
              {[Globe, Camera, Share2, MessageSquare].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-orange-500 hover:border-orange-500 hover:shadow-[0_0_15px_rgba(249,115,22,0.6)] transition-all duration-300">
                  <Icon className="w-4 h-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[3px] text-white mb-8">Hotel</h4>
            <ul className="space-y-4 text-gray-400 text-[13px] font-light tracking-wide">
              {['Home', 'Rooms', 'Amenities', 'Gallery', 'Offers'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase()}`} className="hover:text-orange-400 transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[3px] text-white mb-8">Services</h4>
            <ul className="space-y-4 text-gray-400 text-[13px] font-light tracking-wide">
              {['Room Service', 'Airport Pick-up', 'Spa & Wellness', 'Conference Room', 'Restaurant'].map((item) => (
                <li key={item}>
                  <a href="#" className="hover:text-orange-400 transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[3px] text-white mb-8">Stay Updated</h4>
            <p className="text-gray-400 text-[13px] mb-6 font-light">Join our newsletter for exclusive offers and news.</p>
            <div className="relative">
              <input 
                type="email" 
                placeholder="Email Address" 
                className="w-full bg-white/5 border border-white/10 rounded-full py-4 px-6 outline-none focus:border-orange-500 transition-colors text-sm font-light text-white placeholder-gray-500" 
              />
              <button className="absolute right-2 top-2 bottom-2 bg-gradient-to-r from-orange-500 to-yellow-600 px-6 rounded-full font-bold text-[10px] tracking-widest uppercase hover:from-orange-600 hover:to-yellow-700 transition-all shadow-[0_0_10px_rgba(249,115,22,0.4)]">
                JOIN
              </button>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-gray-500 text-xs font-medium tracking-widest">
            © 2026 GPHUB LUXURY SUITES. ALL RIGHTS RESERVED.
          </p>
          <div className="flex gap-8 text-gray-500 text-xs font-medium tracking-widest">
            <a href="#" className="hover:text-white">PRIVACY POLICY</a>
            <a href="#" className="hover:text-white">TERMS OF SERVICE</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
